import React, { useEffect, useState, useCallback } from "react";
import WalletComponent from "./WalletComponent";
import "../../iframe.threeds.css";
import CardComponent from "./CardComponent";
import * as Api from "../../api/app";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

export const DojoCheckout = ({ setFinalLoading, isFinalLoading, paymentAmount }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [pi, setPi] = useState(null);
  const [errors, setErrors] = useState([]);
  const orderId = location.state.orderId;
  const displayAmount =
    typeof pi?.amount?.value === "number"
      ? pi.amount.value / 100
      : paymentAmount;

  // load Dojo Script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.dojo.tech/payments/v1/client.js";
    script.async = true;
    document.body.appendChild(script);

    let isMounted = true;
    script.onload = () => {
      if (isMounted) {
        console.log("Dojo script loaded successfully");
        setFinalLoading(false);
      }
    };

    return () => {
      isMounted = false;
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [setFinalLoading]);

  const loadPaymentIntent = useCallback(async () => {
    try {
      const res = await Api.getDojoPaymentDetails(orderId);
      setPi(res?.data);
      console.log("Checkout call payment intent loaded", res?.data);
    } catch (error) {
      console.error("Error loading payment intent:", error);
      setErrors((prev) => [...prev, "Failed to load payment details"]);
    }
  }, [orderId]);

  useEffect(() => {
    loadPaymentIntent();
  }, [loadPaymentIntent]);

  const paymentComplete = useCallback(() => {
    navigate(`/order-success-dojo/${orderId}`);
  }, [navigate, orderId]);

  const refreshClientSessionSecret = useCallback(async () => {
    console.log("Refreshing client session...");
    try {
      const res = await Api.getDojoPaymentDetails(orderId);
      setPi(res?.data);
      console.log("Client session refreshed", res?.data);
    } catch (error) {
      console.error("Error refreshing client session:", error);
      setErrors((prev) => [...prev, "Failed to refresh payment session"]);
    }
  }, [orderId]);

  return (
    <>
      <div
        className="item"
        style={{ padding: "20px", width: "100%", boxSizing: "border-box" }}
      >
        <div className="checkout-details">
          <div>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                mt: "64px",
                textAlign: "center",
                mb: 2,
              }}
            >
              Amount due: £{displayAmount ?? 0}
            </Typography>
          </div>
          {!isFinalLoading && (
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "fit-content",
                minWidth: "300px",
              }}
            >
              <WalletComponent
                paymentIntent={pi}
                onPaymentSuccess={paymentComplete}
                onPaymentError={setErrors}
              />
              <hr />
              <CardComponent
                paymentIntent={pi}
                onPaymentSuccess={paymentComplete}
                onPaymentError={setErrors}
                onRefreshPaymentIntent={refreshClientSessionSecret}
              />
            </div>
          )}

          <div
            id="errors"
            className="errors"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minWidth: "300px",
              marginTop: "20px",
              color: "red",
            }}
          >
            {errors.map((error, index) => (
              <div key={index}>{error}</div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
